import React, { useEffect, useState } from "react";
import { Modal, Typography, Box, Backdrop, Button } from '@mui/material';
import { API, graphqlOperation } from "aws-amplify";
import { deleteCrDrNoteMaster } from '../../graphql/mutations';
import { LoadingButton } from "@mui/lab";
import { getTransactionRelation } from "../../graphql/queries";
import { showSuccessSnackbar, showWarningSnackbar } from "../snackBar/snakbar";


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    outline: "none",
    borderRadius: "4px"
};

const DeleteSelectedCrDrNoteMaster = ({ open, setOpen, itemsData, rows, setRows, setSelected, listCreditDebitMaster, setSummaryData, }) => {
    const [finishedArr, setFinishedArr] = useState([])
    const [loading, setLoading] = useState(false);
    const [itemsCannotBeDeleted, setitemsCannotBeDeleted] = useState([])
    console.log(itemsData)
    const handleClose = (event, reason) => {
        if (reason !== 'backdropClick') {
            setOpen(false);
        }
    }

    async function deletCrdrMasterDet(data) {
        try {


            console.log(data)
            const ress = await API.graphql(
                graphqlOperation(getTransactionRelation, { ObjectID: data })
            )
            let linkedPaymentDetails = ress.data.getTransactionRelation.filter((ele) => {
                if (ele.IsDirect == 1) {
                    return ele
                }
            })
            console.log(linkedPaymentDetails)
            if (linkedPaymentDetails.length) {
                setFinishedArr(prev => ([
                    ...prev,
                    { voucher: data, status: false }
                ]))

                if (itemsData.length == 1) {
                    setSelected([])
                }
                return
            }


            const res = await API.graphql(
                graphqlOperation(deleteCrDrNoteMaster, { CrDrNoteID: data })
            )
            if (res.data?.deletePurchaseMaster != null) {
                setFinishedArr(prev => ([
                    ...prev,
                    { voucher: data, status: true }
                ]))
            } else {
                setFinishedArr(prev => ([
                    ...prev,
                    { voucher: data, status: false }
                ]))
            }
        } catch (error) {
            console.log(error);
        }

    }

    useEffect(() => {
        if (itemsData?.length > 0) {

            if (finishedArr.length == itemsData?.length) {
                let arr = rows.filter((item, ind) => {

                    let found = finishedArr.find((elem) => elem.voucher === item?.CrDrNoteID && elem.status)
                    if (!found) {
                        return item
                    }
                })
                let deleted = finishedArr.filter((elem => elem.status))
                let notdeleted = finishedArr.filter((elem => !elem.status))
                if (deleted.length) {
                    listCreditDebitMaster(false, rows.length, finishedArr.length);
                }
                if (deleted.length == 1 && !notdeleted.length) {
                    showSuccessSnackbar("Purchase Deleted")
                }
                else if (deleted.length > 1 && !notdeleted.length) {
                    showSuccessSnackbar("Purchases Deleted")
                }
                else if (notdeleted.length == 1 && deleted.length == 0) {
                    showWarningSnackbar("Linked Payments exists. Please unlink the linked payments before deletion!")
                }
                else {
                    setSummaryData({
                        open: true,
                        description: "Vouchers linked with payments or receipts could not be deleted. Please unlink the following purchase vouchers before trying to delete !",
                        vouchers: [...notdeleted.map((elem) => elem.voucher)]
                    })
                    // showWarningSnackbar("Some of the Purchase cannot be deleted. Please unlink the linked payments before deletion ")
                }

                setRows(arr)
                setOpen(false)
                setLoading(false)
                setFinishedArr([])
            }
        }
    }, [finishedArr])

    const deleteItem = () => {
        if (itemsData?.length > 0) {
            setLoading(true)
            itemsData.map((item) => {
                deletCrdrMasterDet(item)
            })

        }
    }

    return (

        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            {/* <Fade in={open}> */}
            <Box sx={style}>
                <Box sx={{
                    borderRadius: "4px",
                    backgroundColor: "white",
                    padding: "15px",
                    textAlign: "center",
                    overflowY: { xs: 'scroll', sm: 'hidden' },
                    '.MuiTableCell-root': {
                        padding: '10px 10px',
                        fontSize: '13px'
                    },
                }}>

                    <Typography sx={{ color: "rgb(60 60 60)", fontWeight: "bold" }}>
                        Do you want to delete this item?
                    </Typography>

                </Box>


                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    // flexDirection: { xs: 'column', sm: 'row' },
                    paddingLeft: "15px",
                    paddingRight: "15px",
                    paddingBottom: "15px",
                }}>
                    <Button onClick={handleClose} disabled={loading} variant='outlined' sx={{ flex: 1, margin: '5px', fontSize: "12px" }} >No</Button>
                    {/* <Button color="error" onClick={deleteItem} variant='contained' sx={{flex:1,margin:'5px', fontSize : "12px"}} >Yes</Button> */}
                    <LoadingButton color="error" sx={{ flex: 1, margin: '5px', fontSize: "12px" }} loading={loading} disableRipple={true} variant="contained" onClick={() => deleteItem()}>
                        Yes
                    </LoadingButton>
                </Box>


            </Box>
            {/* </Fade> */}
        </Modal>

    );
};

export default DeleteSelectedCrDrNoteMaster;